import { IParamsToSend } from '@base/@types/providers/Kpi/RuptureProvider'

export const ruptureIndicatorsRequest: IParamsToSend = {
  empresa: {
    ids: [],
    agrupar: false
  },
  tipoCentro: {
    ids: [],
    agrupar: false
  },
  loja: {
    ids: [],
    agrupar: false
  },
  gerenteCategoria: {
    ids: [],
    agrupar: false
  },
  gerenteProduto: {
    ids: [],
    agrupar: false
  },
  mundo: {
    ids: [],
    agrupar: false
  },
  categoriaCompacta: {
    ids: [],
    agrupar: true
  },
  categoria: {
    ids: [],
    agrupar: false
  },
  statusEstoque: {
    ids: [],
    agrupar: false
  },
  curvaABC: {
    descricoes: [],
    agrupar: false
  },
  fornecedor: {
    ids: [],
    agrupar: false
  },
  subCategoria: {
    ids: [],
    agrupar: false
  },
  periodo: {
    inicio: new Date().toISOString(),
    final: new Date().toISOString(),
    agrupar: true
  }
}
